import React from "react"
import BackgroundImage from "gatsby-background-image"
import { BaseBlockContent } from "@utils/richText"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

const Hero = ({ city, state, herobg, title }) => {
  const image = convertToBgImage(getImage(herobg.childImageSharp.gatsbyImageData))

  return (
    <BackgroundImage
      {...image}
      className="hero-city-container"
    >
      <div className="hero-city-wrapper">
        <div className="hero-city-content">
          <h1 className="title"> {/*The city title and the header come from different sections on sanity, so a bit of manipulation was needed to get them both inside the H1 */}
          {typeof state == "undefined" ? (
            <span className="our-city">{`${city}`}</span>
          ) : (
            <span className="our-city">{`${city}, ${states[state] || state}`}</span>
          )}
          <span className="headline">{`${title[0].children[0].text} ${title[1].children[0].text}`}</span>
          </h1>
        </div>
      </div>
    </BackgroundImage>
  )
}

export default Hero

const states = {
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  "District of Columbia": "DC",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
}
